<template>
  <div class="game-page">
<!--    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="" left-arrow @click-left="$router.push('/home')" />-->
    <div data-v-b04cd74c="" class="head" v-if="head_status">
      <img data-v-b04cd74c=""
           src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABQCAMAAABVumeJAAAAV1BMVEUAAAAXIkohIUcdJEgdJEgdJUgmJlMdJEkcJUgdJUgdJUgcJUgZJUgdJUgdJUgdJEgdJUcdJUghIUccJEgdJUgfKUcdJEgeJUgdJ0UdJUgdJkccJkwdJUhEH/ptAAAAHHRSTlMACw/KxcIGEby3qs0UntXY0KMXsPAZlWca5nobAFu9RgAAAJ1JREFUSMft10kSgjAQQNEmCWICMSJBHHL/czpsuspNd1fJnL9+F/jAqvAxOcW0ZXqnFdN+8wKbIsOahJht05WyCq0t1mWP2TKtzvbHlluz1RJsne2nBq2hLDiBBYlFbA80biVamRG1nkR3u9CO1pVM19No+LNuzqvX7cz6tBR9Qe03rMN4ukc9SLQFultAzNcDcHoGfBq6vov3B8AL7dpTX/nqleQAAAAASUVORK5CYII="
           style="width: 11px; height: 20px;"
           @click="back()"
      >
      <div data-v-b04cd74c="" class="head-text"> </div>
      <img data-v-b04cd74c="" src="/static/img/more.png" alt="" class="right" @click="modal_state = true" v-if="platname && platname.length > 0">
    </div>
<!--    <div v-if="loading">-->
<!--&lt;!&ndash;      <van-skeleton title row="10"/>&ndash;&gt;-->
<!--      <div class="loading-animation">-->
<!--&lt;!&ndash;        <img src="/static/img/apng_loading_game.png" />&ndash;&gt;-->
<!--        <img src="/static/image/new/loading.gif" alt="">-->
<!--&lt;!&ndash;        <div class="loading-text">加载中</div>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <div class="iframe-wrapper">
<!--      <iframe scrolling="auto" frameborder="0" :src="url"  @load="onLoad" style="display:none" v-if="!ready"></iframe>-->
      <iframe style="height: 100%; width: 100%;overflow-y: auto;border: 0;" ref="iframe" scrolling="yes" frameborder="0"  :src="url"  @load="onLoad" id="iframe"></iframe>
      <div class="transfer-modal" v-if="modal_state">
        <div class="transfer-modal-content">
          <div class="transfer-tab">
            <div :class="{'tab-item': true, 'active': item.type === transfer_type}" v-for="(item,index) in tab_list" :key="index" @click="toggleTabs(item.type)">{{ item.title }}</div>
          </div>
          <div class="transfer-info">
            <div :class="{'first-handle': true, 'reverse-row': transfer_type === 2}">
              <div class="item">
                {{ $t('余额') }}: <span class="balance">{{ amount1 || '0.00' }}</span>
              </div>
              <img src="/static/img/arrow-down.png" class="item icon">
              <div class="item">
                {{targettype.name}}:<span class="balance"> {{ targettype.balance || '0.00' }}</span>
              </div>
            </div>
            <div class="transfer-all" @click="transferAll">{{ $t('全部转入') }}</div>
          </div>
          <div class="transfer-input">
            <div class="unit"></div>
            <input type="text" :placeholder="$t('请输入金额')" v-model="amount">
            <div class="submit" @click="submit()">{{ $t('转入') }}</div>
          </div>
          <div class="remove-amount" @click="modal_state = false">{{ $t('取消') }}</div>
        </div>
        <img src="/static/img/close-white.png" class="close-btn" @click="modal_state = false"></img>
      </div>
    </div>



  </div>
</template>
<script>
import {translateText, isMobile} from "../../common/utils";

export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      loading: true,

      platname: '',

      isBack: 0,     // 1- 返回上一页
      modal_state: false,
      transfer_type: 1,  // 转入类型   1- 平台钱包-其他钱包  2-其他钱包-平台钱包

      tab_list: [
        {
          title: this.$t('转入'),
          type: 1
        },
        {
          title: this.$t('转出'),
          type: 2
        },
      ],
      sourcetype: { platname: 'userbalance', name: this.$t('平台钱包'), balance: 0},


      targettype: {},

      amount: "",
      ready: false,
      iframeSrc: '',

      head_status: true,
      mql: null,
    };
  },
  created() {
    var query = this.$route.query;
    // 打开代理
    if (query.dailiD == 1) {
      this.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      this.getservicerurl();
      return;
    }
    if (query.app == 1) {
      this.url = this.$store.state.appInfo.ios_download_url;
      return;
    }
    if(query.platname) {
      this.platname = query.platname
    }
    if(query.isBack) {
      this.isBack = query.isBack
    }


    // if (query.name) {
    //   this.goGamePage(query.name, query.type, query.code);
    // }

    if(query.url) {
      this.url = query.url
      // console.log(this.url);
      // 提前建立连接，减少 DNS/TLS 耗时
      this.showLoading();
    }


    this.getbalancelist()


  },

  mounted() {
    // this.$refs.iframe.contentWindow.location.replace(this.url);
    // 延迟一点再赋值 iframe.src，让浏览器先预加载资源
    // setTimeout(() => {
    //   this.iframeSrc = this.url
    // }, 200) // 200ms延迟效果最佳
    let that = this;
    window.addEventListener("message", function(event) {
      if (event.data === "doSomething") {
        // 比如执行某个逻辑、刷新、操作 DOM
        that.modal_state = true;
      }
      if(event.data === "loadingFinish") {
        that.hideLoading()
      }
    });

    this.mql = window.matchMedia("(orientation: landscape)");

    this._orientationHandler = (e) => {
      this.checkOrientation(e);
    };
    this.checkOrientation(this.mql);
    if (this.mql.addEventListener) {
      this.mql.addEventListener("change", this._orientationHandler);
    } else {
      this.mql.addListener(this._orientationHandler);
    }

  },
  updated() {
    let that = this;
  },
  computed: {
    amount1() {
      return this.$store.state.userInfo.balance + this.$store.state.userInfo.gameblance
    }
  },
  methods: {
    checkOrientation(e) {
      if(isMobile()) {
        this.head_status = !e.matches;
      }
    },
    back() {
      if(this.isBack == 1) {
        this.$router.back()
        return;
      }
      if(this.platname && this.platname.length > 0) {
        this.$router.push('/home')
        return;
      }
      this.$router.back()

    },
    getbalancelist() {
      this.$apiFun
        .post('/api/balancelist', {})
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            let balancelist = res.data;

            let info = {}
            balancelist.forEach((item) => {
              if(item.platname === this.platname) {
                 info = item
              }
            });
            const text = await translateText([info.name])
            this.targettype = {
              ...info,
              name: text[0]
            }
          }
        })
        .catch(res => {
        });
    },
    toggleTabs(type) {
      this.transfer_type = type
      this.amount = ''
    },
    transferAll() {
      if(this.transfer_type === 1) {
        this.amount = this.amount1 || "0.00"
      }else {
        this.amount = this.targettype.balance || "0.00"
      }
    },
    refreshusermoney() {
      this.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          this.$store.commit('changUserInfo');
        }
      });
    },
    submit() {
      if (this.amount == null || this.amount == '') {
        this.$parent.showTost(0, this.$t('请输入操作金额') + '！');
        return;
      }
      if(this.amount === '0.00' || this.amount === '0.000') {
        this.$parent.showTost(0, this.$t('操作金额不能为0') + '！');

        return;
      }
      let info = {
        amount: this.amount,
        sourcetype: this.transfer_type === 1 ? this.sourcetype.platname : this.targettype.platname,
        targettype: this.transfer_type === 1 ? this.targettype.platname : this.sourcetype.platname,
      };
      this.showLoading()
      this.$apiFun.post('/api/transfer', info).then(async (res) => {
        if (res.code === 200) {
          this.$parent.showTost(1, this.$t('转入成功') + '！');

          this.refreshusermoney()
          this.getbalancelist()
        } else {
          this.showTost(1, res.message);
        }
        this.hideLoading();
      }) .catch(res => {
        this.hideLoading();
      });
    },
    removeDomainFromUrl(url) {
      const domainRegex = /^(https?:\/\/)?[^\/\s]+/i;
      return url.replace(domainRegex, "");
    },

    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;

      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(res => {});
    },
    onLoad() {
      setTimeout(() => {
        this.hideLoading();
      }, 3000)
      // const iframe = document.getElementById('iframe');
      // function updateIframeHeight() {
      //   const height = iframe.getBoundingClientRect().height;
      //   iframe.contentWindow.postMessage({
      //     type: 'setIframeHeight',
      //     height
      //   }, '*');
      // }
      // updateIframeHeight();
      // window.addEventListener('resize', updateIframeHeight);

      // const minLoadingTime = 2000
      // const start = Date.now()
      // const done = () => {
      //   const elapsed = Date.now() - start
      //   const wait = Math.max(minLoadingTime - elapsed, 0)
      //   setTimeout(() => {
      //     // this.loading = false
      //
      //   }, wait)
      // }
      //
      // done()
    }
  },
  beforeDestroy() {
    if (this.mql && this._orientationHandler) {
      if (this.mql.removeEventListener) {
        this.mql.removeEventListener("change", this._orientationHandler);
      } else {
        this.mql.removeListener(this._orientationHandler);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-099d4415.690b75b1.css';
.loading-animation{
  //width: 244px;
  //height: 237px;
  //background: url(/static/image/jzz.gif);
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  //background: #000;
  background: rgba(0, 0, 0, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  img {
    width: 60%;
  }
  .loading-text {
    height: 35px;
    margin-top: 151px;
    text-align: center;
  }
}

.game-page {
  //position: fixed;
  //top: 0;
  //left: 0;
  //width: 100vw;
  //z-index: 1;
  width: 100%;
  height: 100%;
  //margin: auto;
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
  bottom: 0;
  bottom: env(safe-area-inset-bottom, 0); /* 兼容刘海/手势栏 */
  .head {
    height: 1.17333rem;
    padding: 0 .26667rem;
    background: #ede9e7;
    border-bottom: .02667rem solid #eceff6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    img {
      height: .88rem;
      border-radius: .53333rem
    }
    .head-text {
      font-size: .48rem;
      color: #1d2548;
      font-weight: 600
    }
    .onlinepng {
      margin-left: 3.06667rem;
      width: .66667rem;
      height: .66667rem;
      margin-top: .26667rem
    }
    .right {
      width: .64rem;
      height: .64rem;
      border-radius: 0
    }
  }
  .iframe-wrapper {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    overscroll-behavior: contain;
  }
  .transfer-modal {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .close-btn {
      position: absolute;
      z-index: 2;
      right: .8rem;
      top: .8rem;
      width: .7rem;
    }
    .transfer-modal-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 78%;
      position: relative;
    }
    .transfer-tab {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ccc;
      height: .6rem;
      border-radius: .6rem;
      width: 5rem;
      .tab-item {
        width: 50%;
        height: 100%;
        border-radius: .6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .38rem;
        &.active {
          background: yellow;
          color: #000;
        }
      }
    }
    .transfer-info {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
      text-align: center;
      margin-top: .6rem;
      .first-handle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &.reverse-row {
          flex-direction: column-reverse;
        }
        .item {
          font-size: .38rem;

          &.icon {
            width: .4rem;
            margin: .2rem 0;
          }
          .balance {
            color: yellow;
            font-size: .38rem;
          }
        }
      }
      .transfer-all {
        color: yellow;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: .38rem;
      }
    }
    .transfer-input {
      height: 1rem;
      margin-top: .2rem;
      border-bottom: 0.04rem solid #eceff6;
      display: flex;
      align-items: center;
      width: 100%;
      .unit {
        width: .6rem;
        flex-shrink: 0;
        font-size: .38rem;
      }
      input {
        height: 100%;
        flex: 1;
        background: transparent;
        outline:none;
        border: none;
        font-size: .38rem;
      }
      .submit {
        background: yellow;
        color: #000;
        height: .6rem;
        line-height: .6rem;
        padding: 0 .3rem;
        border-radius: .4rem;
        margin-left: .3rem;
        flex-shrink: 0;
        font-size: .38rem;
      }
    }
    .remove-amount {
      margin-top: .3rem;
      font-size: .4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue